import React from "react";

import { ReactComponent as LinksUteisIcon } from "../../../assets/novosicones/MeAjuda/LinksUteis.svg";

import "./styles.scss";

const FinanciamentoComponent = ({ tema }) => {
  var redesSociaisRiva = {
    facebook: "https://www.facebook.com/rivaincorporadora",
    youtube: "https://www.youtube.com/c/RivaIncorporadora/featured",
    instagram: "https://www.instagram.com/rivaincorporadora/",
    cor: tema.primaryColor,
  };

  var redesSociaisDirecional = {
    facebook: "https://www.facebook.com/direcionalengenharia",
    youtube: "https://www.youtube.com/user/DirecionalEngenharia",
    instagram: "https://www.instagram.com/direcional_engenharia/",
    cor: tema.primaryColor,
  };

  var redesAtuais = {};
  if (tema.tipo == "Direcional") redesAtuais = redesSociaisDirecional;
  else redesAtuais = redesSociaisRiva;

  return (
    <>
      <div className="centralized-column linksUteis">
        <div
          className="centralized linksUteis__title"
          style={{ height: "50px" }}
        >
          <LinksUteisIcon style={{ fill: tema.primaryColor }} />
          <span
            style={{
              color: tema.primaryColor,
              fontWeight: "900",
              marginLeft: "15px",
            }}
          >
            Links úteis
          </span>
        </div>
        <div className="centralized-column linksUteis__links">
          <a
            className="linksUteis__links__link"
            href={redesAtuais.facebook}
            target="_blank"
            rel="noreferrer"
            style={{ color: redesAtuais.cor }}
            id="linksUteisFacebook"
          >
            Facebook
          </a>
          <a
            className="linksUteis__links__link"
            href={redesAtuais.youtube}
            target="_blank"
            rel="noreferrer"
            style={{ color: redesAtuais.cor }}
            id="linksUteisYoutube"
          >
            Youtube
          </a>
          <a
            className="linksUteis__links__link"
            href={redesAtuais.instagram}
            target="_blank"
            rel="noreferrer"
            style={{ color: redesAtuais.cor }}
            id="linksUteisInstagram"
          >
            Instagram
          </a>
        </div>
      </div>
    </>
  );
};

export default FinanciamentoComponent;
